require('readmore-js');
// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import postTypeArchiveProduct from './routes/post-type-archive-product.js';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  postTypeArchiveProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(".button_read_more").on("click", function() {
      var $this = $(this);
        $this.toggleClass("open");

        if ($this.hasClass("open")) {
            $this.html("Less");
        } else {
            $this.html("Read more");
        }
});

// Read more button
$(".read-more").on("click", function(Event){
  // declare text for read more label 
  var text_more;
  console.log(text_more);
  // declare target collapsible content
  var content_collapse = $(this).data("target");
  // declare text for close label
  var text_close = $("[data-collapse="+content_collapse+"]").data("text-close");
  Event.preventDefault(); 
  // if content is not collapsed  
  if(!$(this).hasClass('collapse-open')){
    $(this).data("text-more", $(this).html());
      text_more = $(this).data("text-more");
      $(this).addClass('collapse-open');  
      $(this).html(text_close);
      $("[data-collapse="+content_collapse+"]").slideDown(300);
      
                
    } else {
      // if content is collapsed
      text_more = $(this).data("text-more");
      $(this).html(text_more);  
      $(this).removeClass('collapse-open');
      $("[data-collapse="+content_collapse+"]").slideUp(300);
    }
  })

//
$('.link-staff-card')
  .delay(800)
  .queue(function (next) { 
    $(this).css('display', 'none'); 
    next(); 
  });


// WEBPACK FOOTER //
// ./scripts/main.js